import { useMemo, useRef } from 'react'

import Navigation, { NavGroup } from 'src/components/Sidebar/Navigation/Navigation'
import { useLaunchIntercom } from 'src/hooks/use-launch-intercom'

type Props = {
  isNavGroupOpenMap: Map<string, boolean>
  onToggleNavGroupIsOpen: (key: string) => void
}
const HelpNavItem = ({ isNavGroupOpenMap, onToggleNavGroupIsOpen }: Props) => {
  const itemRef = useRef<HTMLElement>(null)

  const { launchIntercom } = useLaunchIntercom()

  const navElements: NavGroup[] = useMemo(
    () => [
      {
        icon: 'FaQuestionCircle',
        items: [
          {
            externalHref: 'https://help.govwell.com/en/',
            isActive: false,
            openInNewTab: true,
            title: 'Help Center',
          },
          {
            isActive: false,
            onClick: launchIntercom,
            title: 'Chat With Us',
          },
        ],
        key: 'get-help',
        ref: itemRef,
        title: 'Get Help',
      },
    ],
    [launchIntercom]
  )

  return (
    <Navigation
      elements={navElements}
      isNavGroupOpenMap={isNavGroupOpenMap}
      onToggleIsOpen={onToggleNavGroupIsOpen}
    />
  )
}

export default React.memo(HelpNavItem)
